import { withOverrideLegacy } from '~/App/hocs/with-override-legacy';

import { Articles } from './Articles';
import { loadData } from './Articles.LoadData';

export default withOverrideLegacy(Articles, loadData);
